import {useSelector} from 'react-redux';

/**
 * Whether the Open Banking account-access list has finished its initial fetch.
 * @returns {boolean}
 */
export const useIsAccountAccessLoaded = () => useSelector(state => state.openBanking.accountAccessLoaded);
